<template>
  <div class="overflow-hidden">
    <img
      src="img/camillo-coda-1.gif"
      class="fixed pin-r pt-32"
      style="margin-right: -270px; transform: rotate(45deg); padding-top: 290px;"
    >
    <div class="container mx-auto px-4 relative z-10">
      <div class="pt-20">
        <div class="text-center px-10 pb-5">
          <img
            src="img/Logo_Camillo.svg"
            alt="Camillo"
          >
        </div>
        <form
          @submit.prevent="handleSubmit"
          class="rounded px-4 pt-6 pb-8 mb-4"
        >
          <h3 class="text-center pt-4 pb-4">{{$t('all.auth_reset_password')}}</h3>
          <div class="mb-4 ">
            <input
              type="password"
              v-model="password"
              name="password"
              :placeholder="$t('all.common_password')"
              class=" appearance-none border w-full py-4 px-4 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
              :class="{ 'border-red': submitted && !password }"
            />
            <div
              v-show="submitted && !password"
              class="text-red text-xs italic"
            >
              {{$t('all.auth_insert_password')}}
            </div>
          </div>
          <div class="mb-4 ">
            <input
              type="password"
              v-model="password2"
              name="password2"
              :placeholder="$t('all.auth_confirm_password')"
              class=" appearance-none border w-full py-4 px-4 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
              :class="{ 'border-red': submitted && !password2 }"
            />
            <div
              v-show="submitted && !password2 || error"
              class="text-red text-xs italic"
            >
              {{$t('all.auth_password_match')}}
            </div>
          </div>
          <div class="mb-6 items-center justify-between">
            <button class="w-full bg-blue-dark block hover:bg-blue-dark text-white font-bold py-4 px-6 rounded focus:outline-none focus:shadow-outline">
              {{$t('all.common_change_password')}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      password: null,
      password2: null,
      error: false,
      submitted: false,
    };
  },
  created() {
    this.logout();
  },
  computed: {},
  methods: {
    ...mapActions('authentication', ['resetPassword', 'logout']),
    handleSubmit(e) {
      this.submitted = true;
      const token = this.$route.query.token;
      const { password, password2 } = this;
      if (password && password2 && password === password2) {
        this.resetPassword({ password, token });
      } else {
        this.error = true;
      }
    },
  },
};
</script>
